// eslint-disable-next-line import/no-unresolved
import { strings as AquaStrings } from '@headout/aqua/strings';

const strings: any = AquaStrings;

export { strings };
